import * as React from 'react'

import BaseTextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
}

const cleaveOptions = {
  creditCard: true,
}

function CreditCardTextField(props: IProps) {
  const { onChange, ...moreProps } = props

  return (
    <BaseTextField
      {...moreProps}
      cleaveOptions={cleaveOptions}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

CreditCardTextField.defaultProps = defaultTextFieldProps

export default React.memo(CreditCardTextField)
